/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerTeamMemberDtoSchema = z.object({
  name: z.optional(z.string()),
  role: z.optional(z.string()),
  fte: z.optional(z.string()),
  group: z.optional(z.string()),
});
